import type { TemplateOnlyComponent } from '@ember/component/template-only';

const LibraryFolders: TemplateOnlyComponent = <template>{{outlet}}</template>;

export default LibraryFolders;
